<app-select-input
    [infiniteScroll]="specializations()"
    [form]="form"
    [id]="id"
    [label]="label"
    idField="code"
    valueKey="code"
    labelKey="name"
    filterBy="name,code"
>
    <ng-template #item let-item>
        <div class="flex flex-row gap-small">
            @if (item.code?.length) {
                {{ item.code }}
            }
            @if (item.name?.length) {
                {{ item.name }}
            }
        </div>
    </ng-template>
</app-select-input>
